import { VARIANT } from '@atoms/Button/Button.types';
import Image from 'next/image';
import type { ReactElement } from 'react';

import { Highlight } from '@/styles/shared';

import { SectionWrap } from '../SectionWrap/SectionWrap';
import {
  ArrowIcon,
  ButtonWrapper,
  ContentColumn,
  CtaButton,
  HeroQuoteAuthor,
  HeroQuoteAvatar,
  HeroQuoteCard,
  HeroQuoteHeader,
  HeroQuoteHighlight,
  HeroQuoteMeta,
  HeroQuoteRating,
  HeroQuoteText,
  ImageColumn,
  ImageWrapper,
  StatsMiniIcon,
  StatsMiniItem,
  StatsMiniNumber,
  StatsMiniText,
  StatsMiniWrapper,
  Subtitle,
  Title,
  TitleLine,
  TrustBadgeIcon,
  TrustBadgeItem,
  TrustBadgeLabel,
  TrustBadgesWrapper,
  Wrapper,
} from './Hero.styled';

export const Hero = ({
  onCallToActionClick,
  onSecondaryActionClick,
}: {
  onCallToActionClick: () => void;
  onSecondaryActionClick: () => void;
}): ReactElement => (
  <SectionWrap>
    <Wrapper>
      <ContentColumn>
        <Title>
          <TitleLine>Zaplanuj wyjazd na Teneryfę</TitleLine>
          <Highlight as="span">szybciej i&nbsp;taniej</Highlight>
        </Title>
        <Subtitle>
          Skorzystaj z&nbsp;gotowych tras, sprawdzonych miejsc
          i&nbsp;praktycznych wskazówek. Zaoszczędź godziny na planowaniu
          i&nbsp;uniknij turystycznych pułapek.
        </Subtitle>

        <StatsMiniWrapper>
          <StatsMiniItem>
            <StatsMiniIcon>✅</StatsMiniIcon>
            <StatsMiniText>
              <StatsMiniNumber>170 stron</StatsMiniNumber> praktycznej wiedzy
              opartej na&nbsp;doświadczeniu
            </StatsMiniText>
          </StatsMiniItem>
          <StatsMiniItem>
            <StatsMiniIcon>✅</StatsMiniIcon>
            <StatsMiniText>
              <StatsMiniNumber>170 sprawdzonych miejsc</StatsMiniNumber>{' '}
              na&nbsp;całej wyspie
            </StatsMiniText>
          </StatsMiniItem>
          <StatsMiniItem>
            <StatsMiniIcon>✅</StatsMiniIcon>
            <StatsMiniText>
              <StatsMiniNumber>35 plaż</StatsMiniNumber> z&nbsp;opisem dojazdu,
              warunków i&nbsp;udogodnień
            </StatsMiniText>
          </StatsMiniItem>
        </StatsMiniWrapper>

        <ButtonWrapper>
          <CtaButton onClick={onCallToActionClick}>
            Pobierz przewodnik
            <ArrowIcon viewBox="0 0 28 10">
              <path
                d="M0 5H26M26 5L21 1M26 5L21 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </ArrowIcon>
          </CtaButton>
          <CtaButton
            variant={VARIANT.SECONDARY}
            onClick={onSecondaryActionClick}
          >
            Zobacz treść
          </CtaButton>
        </ButtonWrapper>

        <TrustBadgesWrapper>
          <TrustBadgeItem>
            <TrustBadgeIcon>⚡</TrustBadgeIcon>
            <TrustBadgeLabel>Dostęp od razu po zakupie</TrustBadgeLabel>
          </TrustBadgeItem>
          <TrustBadgeItem>
            <TrustBadgeIcon>⏱️</TrustBadgeIcon>
            <TrustBadgeLabel>Oszczędzasz godziny researchu</TrustBadgeLabel>
          </TrustBadgeItem>
          <TrustBadgeItem>
            <TrustBadgeIcon>🔄</TrustBadgeIcon>
            <TrustBadgeLabel>
              Aktualizacje przewodnika w&nbsp;cenie
            </TrustBadgeLabel>
          </TrustBadgeItem>
        </TrustBadgesWrapper>
      </ContentColumn>

      <ImageColumn>
        <ImageWrapper>
          <Image
            src="/static/images/teneryfa/cover.jpg"
            alt="Okładka przewodnika po Teneryfie na ekranie tabletu, który leży na mapie"
            fill
            sizes="(max-width: 992px) 100vw, 50vw"
            style={{ objectFit: 'cover' }}
          />
        </ImageWrapper>

        <HeroQuoteCard>
          <HeroQuoteHeader>
            <HeroQuoteAvatar>
              <Image
                src="/static/images/avatars/beata.jpg"
                alt="Beata Sz."
                fill
                sizes="34px"
                style={{ objectFit: 'cover' }}
              />
            </HeroQuoteAvatar>
            <HeroQuoteMeta>
              <HeroQuoteAuthor>Beata Sz.</HeroQuoteAuthor>
              <HeroQuoteRating>★★★★★</HeroQuoteRating>
            </HeroQuoteMeta>
          </HeroQuoteHeader>
          <HeroQuoteText>
            <HeroQuoteHighlight lineIndex={0}>
              Żałuję, że go nie miałam
            </HeroQuoteHighlight>{' '}
            <HeroQuoteHighlight lineIndex={1}>
              podczas pierwszej podróży na&nbsp;Teneryfę.
            </HeroQuoteHighlight>
          </HeroQuoteText>
        </HeroQuoteCard>
      </ImageColumn>
    </Wrapper>
  </SectionWrap>
);
